import { LoadingState } from './types'
import { StkDataObj } from '../../../Data'

export interface StkWidgetState {
  loadingState: LoadingState
  stkSummaryData: StkDataObj | null
  activeAccountId: string
  errorMsg: string
}

export enum StkWidgetActionType {
  SET_ACTIVE_ACCOUNT_ID = 'setActiveAccountId',
  LOADING = 'loading',
  SUCCESS = 'success',
  ERROR = 'error',
}

export type StkWidgetAction =
  | {
      type: StkWidgetActionType.SET_ACTIVE_ACCOUNT_ID
      value: string
    }
  | {
      type: StkWidgetActionType.LOADING
    }
  | {
      type: StkWidgetActionType.SUCCESS
      payload: StkDataObj | null
    }
  | {
      type: StkWidgetActionType.ERROR
    }

export const StkWidgetReducer = (
  state: StkWidgetState,
  action: StkWidgetAction,
): StkWidgetState => {
  switch (action.type) {
    case StkWidgetActionType.SET_ACTIVE_ACCOUNT_ID: {
      return {
        ...state,
        activeAccountId: action.value,
      }
    }
    case StkWidgetActionType.LOADING: {
      return {
        ...state,
        loadingState: LoadingState.LOADING,
        errorMsg: '',
      }
    }
    case StkWidgetActionType.SUCCESS: {
      return {
        ...state,
        loadingState: LoadingState.LOADED,
        stkSummaryData: action.payload,
      }
    }
    case StkWidgetActionType.ERROR: {
      const errorMsg =
        "We're currently unable to retrieve your buckets and boosters details."
      return {
        ...state,
        loadingState: LoadingState.ERROR,
        errorMsg,
        stkSummaryData: null,
      }
    }
    default: {
      return {
        ...state,
      }
    }
  }
}
